'use client'

import React from 'react'

import { Box } from '@chakra-ui/react'

import { tableHeaderStyles } from './Table.styles'
import { useTableColorScheme, useTableDensity } from './TableContext'

export type TableHeaderProps = {
  children: React.ReactNode
}

export const TableHeader = ({ children }: TableHeaderProps) => {
  const colorScheme = useTableColorScheme()
  const density = useTableDensity()
  return <Box {...tableHeaderStyles(colorScheme, density)}>{children}</Box>
}
